// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_EDL7J","current":"index_current_k13xz","data":"index_data_yuCQr","red":"index_red_TsEkK"};